import { useCallback } from 'react';
import { RootStateOrAny, useSelector, useDispatch } from 'react-redux';
import { ListBusinessActions } from 'store/ducks/settings/business';

type State = {
  data: { value: number, label: string }[];
  loading: boolean;
}

export function useListBusiness() {
  const dispatch = useDispatch();

  const { data: business, loading: loadingBusiness } =
    useSelector<RootStateOrAny, State>(
      (state) => state.listBusiness);

  const fetchBusiness = useCallback((
    unitId: string | number,
    onSuccess?: (options: State['data']) => void,
  ) => {
    const payload = {
      general_business_line_unit_id: unitId,
      all: true,
    };

    dispatch(ListBusinessActions.request(payload, onSuccess));
  }, []);

  return {
    business,
    loadingBusiness,
    fetchBusiness,
  };
}